import getters from "./getters";
import actions from "./actions";
import * as types from "./../action-types";
import { cloneDeep, extend, get, concat } from "lodash";

let initRequestList = (requests) => ({
  replacements: get(requests, "replacement", []),
  parts: get(requests, "parts", []),
  one_offs: get(requests, "one_off", []),
  refunds: get(requests, "refund", []),
});

const initialState = () =>
  cloneDeep({
    list: {
      replacements: [],
      parts: [],
      one_offs: [],
      refunds: [],
    },
    requestInProgress: {
      general: {},
      customer: {},
      address: {},
      product: {},
      misc: {},
      reasons: {},
    },
    requestFlow: {
      oneoff: {},
      replacement: { allReasons: [], reasonGroups: [] },
    },
  });

const mutations = {
  [types.FETCH_ACCOUNT_REQUESTS.SUCCESS](state, { requests }) {
    state.list = initialState().list;
    Object.assign(state.list, initRequestList(requests));
  },
  [types.FETCH_ACCOUNT_REQUESTS.ERROR](state, error) {
    console.info("FETCH_ACCOUNT_REQUESTS.ERROR", error);
  },
  [types.SET_REQUEST_GENERAL_DATA](state, data) {
    extend(state.requestInProgress.general, data);
  },
  [types.SET_REQUEST_CUSTOMER_DATA](state, data) {
    extend(state.requestInProgress.customer, data);
  },
  [types.SET_REQUEST_ADDRESS_DATA](state, data) {
    extend(state.requestInProgress.address, data);
  },
  [types.SET_REQUEST_PRODUCT_DATA](state, data) {
    extend(state.requestInProgress.product, data);
  },
  [types.SET_REQUEST_MISC_DATA](state, data) {
    extend(state.requestInProgress.misc, data);
  },
  [types.SET_REQUEST_REASONS_DATA](state, data) {
    extend(state.requestInProgress.reasons, data);
  },
  [types.UPDATE_REQUEST_DATA](state, data) {
    const request = concat(state.list.replacements, state.list.refunds).find(
      (request) => request.uuid == data.request_uuid
    );
    Object.assign(request, { return_label_id: data.tracking_number });
  },
  [types.RESET_REQUEST_DATA](state) {
    state.requestInProgress = {
      customer: {},
      product: {},
      address: {},
      misc: {},
      general: {},
      reasons: {},
    };
  },
  storeReplacementReasons(state, { allReasons, reasonGroups }) {
    state["requestFlow"].replacement.allReasons = allReasons;
    state["requestFlow"].replacement.reasonGroups = reasonGroups;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  resetRequestFlow(state) {
    const emptyState = initialState();
    Object.assign(state.requestFlow, emptyState.requestFlow);
  },
};

// Add non asynchronous actions
Object.assign(actions, {
  async setGeneralData({ commit }, data) {
    commit(types.SET_REQUEST_GENERAL_DATA, data);
    return data;
  },
  async setCustomerInformation({ commit }, data) {
    commit(types.SET_REQUEST_CUSTOMER_DATA, data);
    return data;
  },
  async setAddressInformation({ commit }, data) {
    commit(types.SET_REQUEST_ADDRESS_DATA, data);
    return data;
  },
  async setProductInformation({ commit }, data) {
    commit(types.SET_REQUEST_PRODUCT_DATA, data);
    return data;
  },
  async setMiscInformation({ commit }, data) {
    commit(types.SET_REQUEST_MISC_DATA, data);
    return data;
  },
  async setReasonInformation({ commit }, data) {
    commit(types.SET_REQUEST_REASONS_DATA, data);
    return data;
  },
  async resetRequestInProgress({ commit }) {
    commit(types.RESET_REQUEST_DATA);
  },
});

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
};
